import styled from "styled-components";

export const Title = styled.div`
  font-family: 'Outfit';
  font-weight: 500;
  font-size: 30px;
  line-height: 33px;
  color: #fff;
`;
